@if (problem(); as reason) {
  @if (!dismissed()) {
    <div
      role="status"
      data-testid="gmail-banner"
      class="flex items-center gap-3 border-b border-accent-100 bg-accent-50 px-4 py-2 max-md:flex-wrap max-md:gap-2 max-md:py-3"
    >
      <i class="fas fa-envelope text-accent" aria-hidden="true"></i>
      <p
        data-testid="gmail-banner-text"
        class="m-0 min-w-0 flex-1 text-sm text-ink max-md:basis-[calc(100%-2rem)]"
      >
        <span class="font-semibold">{{ translationService.t('gmailHealth.banner') }}</span>
        <span class="text-ink-2 max-md:block md:before:content-['·_']">{{
          translationService.t('gmailHealth.reason.' + reason)
        }}</span>
      </p>
      <button
        type="button"
        data-testid="gmail-reconnect"
        class="inline-flex min-h-11 items-center justify-center gap-1.5 rounded-md bg-accent px-3.5 text-sm font-semibold text-black transition-colors hover:bg-accent-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent disabled:cursor-not-allowed disabled:opacity-60 max-md:flex-1 md:min-h-8"
        [disabled]="connecting()"
        (click)="reconnect()"
      >
        <i
          [class]="connecting() ? 'fas fa-spinner fa-spin text-xs' : 'fab fa-google text-xs'"
          aria-hidden="true"
        ></i>
        {{ translationService.t('gmailHealth.connect') }}
      </button>
      <button
        type="button"
        class="flex h-11 w-11 shrink-0 items-center justify-center rounded-md text-ink-3 transition-colors hover:bg-accent-100 hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent md:h-8 md:w-8"
        [attr.aria-label]="translationService.t('common.close')"
        [title]="translationService.t('common.close')"
        (click)="dismissed.set(true)"
      >
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>
  }
}
